import baseURL from '../api/url'

const _assortmentURL = endpoint => `${baseURL.CONFIG_URL}/catalogadmin/assortments/${endpoint}`

export const getProductByID = id => _assortmentURL(`products/${id}`)
export const getProductImages = id => `${getProductByID(id)}/images/sync`
export const getSlinListURL = slin => `${_assortmentURL('suggestions/slin')}/${slin}`
export const getUpcListURL = () => _assortmentURL('suggestions/upc')
export const getImportedProductsURL = () => _assortmentURL('imported/fetch')
export const getContainsList = () => _assortmentURL('nutrition/contains')
export const getPrimaryCategoriesURL = () => _assortmentURL('categories')
export const getDynamicCategoriesURL = () => _assortmentURL('dynamic_categories')
export const getTagsList = () => _assortmentURL('tags')
export const getServingSizeUOMURL = () => _assortmentURL('nutrition/serving_size_options')
export const getMarketplacesList = (country, catalog_type) =>
    _assortmentURL(`marketplaces?country=${country}&catalog_type=${catalog_type}`)
export const getEquipmentsList = () => _assortmentURL('equipments')
export const getPublishURL = id => _assortmentURL(`products/${id}/publish`)
export const getUpdatePublishedProduct = id => _assortmentURL(`products/${id}/update`)
export const getDeleteProductURL = () => _assortmentURL('products/delete')
export const setSectionFlagURL = (id, section) => _assortmentURL(`products/${id}/${section}/flag`)
export const clearSectionFlagURL = (id, section) =>
    _assortmentURL(`products/${id}/${section}/clear_flag`)
export const getModifiedAreasURL = () => _assortmentURL('modified_areas')
export const getProductDetailsByID = id => _assortmentURL(`catalog/products/${id}/details`)

export const patchURL = (id, key) => {
    let path = `${getProductByID(id)}`
    if (key) {
        path = path + `/${key}`
    }
    return path
}

export const addNewProductURL = () => _assortmentURL('products/create')
export const importProductURL = () => _assortmentURL('imported/add')
export const deleteImportedProductsURL = () => _assortmentURL('imported/remove')
export const fetchManageUpdatesURL = () => _assortmentURL('products')
export const fetchManageProductsURL = () => _assortmentURL('catalog/products/fetch')
export const updateCatalogProductsURL = id => _assortmentURL(`catalog/products/${id}/update`)
